import { useEffect, useState } from "react";
import ConfirmationModal from "../../../components/atoms/ConfirmationModal";
import {
  Box,
  MenuItem,
  ListItemIcon,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import { DriveFileMove as DriveFileMoveIcon } from "@mui/icons-material";
import useMovetoActiveRef from "./Hooks/useMovetoActiveRef";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {  DesktopDatePicker } from "@mui/x-date-pickers";
import { useDispatch } from "react-redux";
import { clearAllReferralDetail } from "../../../redux/action";

export default function MovetoRefferal({
  CreatedAt,
  selectedId,
  selectedUserId,
  setAnchorEl,
  type
}: any) {
  const dispatch = useDispatch();
  const [dateOption, setDateOption] = useState("original");
  const {
    dateRange,
    isError,
    setIsError,
    isDateRangeAvailable,
    handleModalClose,
    handleModalConfirm,
    isMoveToActiveRef,
    setisMoveToActiveRef,
    selectedDate,
    setSelectedDate,
  } = useMovetoActiveRef({
    selectedId,
    selectedUserId,
    CreatedAt,
    setAnchorEl,
    type
  });

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    setIsError(false)
  };


  useEffect(() => {
    if (dateOption === "original" && CreatedAt) {
      setSelectedDate(new Date(CreatedAt));
    }else{
        setSelectedDate(null);
    }
       // eslint-disable-next-line
  }, [dateOption, isMoveToActiveRef, CreatedAt]);

  const modalMessage = isDateRangeAvailable ? (
    <Box>
      <RadioGroup
        row
        value={dateOption}
        onChange={(e) => setDateOption(e.target.value)}
        sx={{
          justifyContent: "center",
          "label > span.MuiFormControlLabel-label": {
            color: "#000000de",
          },
        }}
      >
        <FormControlLabel
          value="original"
          control={<Radio />}
          label="Original Date"
        />
        <FormControlLabel
          value="range"
          control={<Radio />}
          label="Select Date Range"
        />
      </RadioGroup>
      {dateOption === "range" && (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ my: 2,maxWidth:'380px',mx:'auto' }}>
            <DesktopDatePicker
              label="Select Date"
              value={selectedDate}
              onChange={handleDateChange}
              format="dd/MM/yyyy"
              minDate={new Date(dateRange[0])}
              maxDate={new Date(dateRange[dateRange.length - 1])}
              disableFuture
              slots={{ textField: TextField }}
            />
            {isError && <FormHelperText sx={{color:'red'}}>Please Select a Date</FormHelperText>}
          </Box>
        </LocalizationProvider>
      )}
    </Box>
  ) : (
    "Are you sure you want to Move this Referral in Active Referrals?"
  );
  
  return (
    <>
      <MenuItem
        onClick={() => {
          setisMoveToActiveRef(true);
          dispatch(clearAllReferralDetail());
          setDateOption("original")
        }}
      >
        <ListItemIcon>
          <DriveFileMoveIcon />
        </ListItemIcon>
        Move to Active Referrals
      </MenuItem>

      <ConfirmationModal
        open={isMoveToActiveRef}
        handleClose={handleModalClose}
        title={isDateRangeAvailable ? "Select Date" : "Confirmation"}
        message={modalMessage}
        onConfirm={handleModalConfirm}
        confirmLabel={isDateRangeAvailable ? "Submit" : "Yes"}
        cancelLabel={isDateRangeAvailable ? "Cancel" : "No"}
        onCancel={handleModalClose}
        sxStyle={{py:isDateRangeAvailable ? 1 : 3}}
      />
    </>
  );
}
